import { programTypes, feeStatus, programsObj } from '../../dummy/status';
import { ConvertService } from './../../services/convert.service';
import { AngularFirestore } from '@angular/fire/firestore';
import { AuthService } from '../../auth/auth.service';
import { Component, OnInit, Inject, ViewChild, ElementRef } from '@angular/core';
import { FormGroup, AbstractControl, FormBuilder, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA, MatSnackBar } from '@angular/material';
import { FireValidatorsService } from '../../services/fire-validators.service';
import { ITuition } from '../../interfaces/tuition';
import { MappingService } from '../../services/mapping.service';
import { programs } from 'src/app/dummy/status';
import { Academic } from 'src/app/stores/academic.store';

@Component({
  selector: 'app-add-academic-fee',
  templateUrl: './add-academic-fee.component.html',
  styleUrls: ['./add-academic-fee.component.scss']
})
export class AddAcademicFeeComponent implements OnInit {
  @ViewChild("focusInput") inputEl: ElementRef;

  form: FormGroup;
  code: AbstractControl;
  name: AbstractControl;
  price: AbstractControl;
  program: AbstractControl;
  program_type: AbstractControl;
  description: AbstractControl;
  foreigner: AbstractControl;
  status: AbstractControl;
  campus: AbstractControl;

  programs = programs;
  programTypes = programTypes;
  feeStatus = feeStatus
  campusList = [];

  constructor(
    public dialogRef: MatDialogRef<AddAcademicFeeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: FormBuilder,
    public auth: AuthService,
    private snackBar: MatSnackBar,
    private afs: AngularFirestore,
    public store: Academic
  ) { }

  buildForm(): void {
    this.form = this.fb.group({
      code: [null, Validators.compose([Validators.required]), FireValidatorsService.checkExist(this.afs, 'admission_services', 'code')],
      description: [null],
      campus: [null, Validators.required],
      name: [null, Validators.required],
      price: [null, Validators.required],
      foreigner: [null,],
      program: [this.programs[0], Validators.required],
      program_type: [this.programTypes[0],],
      status: [feeStatus[0], Validators.required]
    })
    this.name = this.form.controls['name'];
    this.campus = this.form.controls['campus'];
    this.description = this.form.controls['description'];
    this.name = this.form.controls['name'];
    this.price = this.form.controls['price'];
    this.foreigner = this.form.controls['foreigner'];
    this.program = this.form.controls['program'];
    this.program_type = this.form.controls['program_type'];
    this.status = this.form.controls['status'];
    if (this.data !== 'all') {
      const key = MappingService.getItemByKey(this.programs, programsObj[this.data]);
      this.form.patchValue({
        program: key
      })
    }
  }

  compareObjects(o1: any, o2: any): boolean {
    if (o2) return o1.key === o2.key;
  }

  async ngOnInit() {
    this.buildForm();

    this.campusList = await this.store.fetchCampus();
    this.form.patchValue({
      campus: this.campusList[0]
    })
  }

  create(f: any, isNew) {
    if (this.form.valid) {
      const formData: ITuition = {
        key: this.afs.createId(),
        code: f.code,
        name: f.name,
        price: f.price,
        campus: f.campus,
        foreigner: ConvertService.toNull(f.foreigner),
        priority: null,
        program: f.program,
        program_type: f.program_type,
        description: f.description,
        status: f.status,
        createDate: new Date(),
        createBy: this.auth.getUser(),
        page_key: ConvertService.pageKey(),
        is_academic: true,
      }

      this.store.save(formData, (success, error) => {
        if (success) {
          const { program_type, program, status, campus } = f;
          if (!isNew)
            this.dialogRef.close();
          this.snackBar.open('Academic Tuition Fee has been created.', 'done', { duration: 2000 });
          this.form.reset();
          this.form.patchValue({
            program: program,
            program_type: program_type,
            status: status,
            campus: campus
          })
          this.inputEl.nativeElement.focus();
        }
        else {
          this.snackBar.open(error, 'Error')
        }
      })
    }
  }

}